'use client';

import { Button, GoogleLogo } from '@baseball-near-you/ui';
import { env } from '@bb/env';
import { QueryKey } from '@bb/lib/hooks/QueryKey';
import { createClient } from '@bb/lib/supabase/client';
import { useQueryClient } from '@tanstack/react-query';
import { usePathname } from 'next/navigation';

export function LoginWithGoogleButton() {
  const pathname = usePathname();
  const queryClient = useQueryClient();

  return (
    <Button
      type="button"
      variant={'outline'}
      className="relative flex w-full items-center"
      onClick={async (e) => {
        e.stopPropagation();
        const supabase = createClient();
        await supabase.auth.signInWithOAuth({
          provider: 'google',
          options: {
            redirectTo: `${env.NEXT_PUBLIC_API_ROOT_URL}/auth/callback?redirect=${pathname}`,
          },
        });
        await queryClient.refetchQueries([QueryKey.User]);
      }}
    >
      <GoogleLogo className="absolute left-3 size-5" />
      Sign in with Google
    </Button>
  );
}
